import React from 'react';
import PropTypes from 'prop-types';
import TextButton from '@spothero/ui/text-button';

const HeroControlsTabDesktop = ({
    spotId,
    operatorNotes,
    spotNotes
}) => {
    return (
        <div className="HeroControlsTab">
            <div className="well well-sm well-dark">
                <TextButton
                    href={`/admin/spots/${spotId}`}
                >
                    Facility Admin Page
                </TextButton>
            </div>
            <h3 className="heading-md">Spot Notes:</h3>
            {(spotNotes && spotNotes.length)
                ? (
                    <ul className="HeroControlsTab-list">
                        {spotNotes.map((note, i) => {
                            return (
                                <li
                                    key={i}
                                    className="HeroControlsTab-list-item"
                                >
                                    <strong>{note.label}</strong>: {note.message}
                                </li>
                            );
                        })}
                    </ul>
                ) : <p>No spot notes saved yet.</p>
            }
            <h3 className="heading-md">Operator Notes:</h3>
            {(operatorNotes && operatorNotes.length)
                ? (
                    <ul className="HeroControlsTab-list">
                        {operatorNotes.map((note, i) => {
                            return (
                                <li
                                    key={i}
                                    className="HeroControlsTab-list-item"
                                >
                                    <strong>{note.label}</strong>: {note.message}
                                </li>
                            );
                        })}
                    </ul>
                ) : <p>No operator notes saved yet.</p>
            }
        </div>
    );
};

HeroControlsTabDesktop.propTypes = {
    spotId: PropTypes.number,
    operatorNotes: PropTypes.arrayOf(PropTypes.object),
    spotNotes: PropTypes.arrayOf(PropTypes.object)
};

export default HeroControlsTabDesktop;
